import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import BaseCertificateModal from "./base-certificate-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'new-certificate-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the property.
   * Defaults to `0` if not provided.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the contact associated with the property.
   * Defaults to `0` if not provided.
   * @type {number}
   * @default 0
   */
  contactId: {
    type: Number,
    default: 0,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the modal is closed.
   * This can be used to notify the parent component that the modal has been dismissed.
   * @property {boolean} certificateCreated - Indicates whether a certificate was successfully created before closing.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const modalClosed = (certificateCreated: boolean) => {
  emit("modalClosed", certificateCreated);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCertificateModal, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    propertyId: Number(props.propertyId),
    contactId: props.contactId,
    onModalClosed: modalClosed
  }, null, 8, ["modelValue", "propertyId", "contactId"]))
}
}

})